<template>
    <div>
        <div class="app-title">
            <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                           :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                           :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"
                                           @showEntityMultipleModalSelect="$_emCommonModalMixin_showMultipleSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesPrdWorkHourRecordResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                      :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                      :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                                      :with-custom-row-actions="viewImageRecord"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow()">
                                <template #right-header>
                                    <mini-button :variant="viewImageRecord?'primary':'outline-primary'"
                                                 @btnClick="viewImageRecord=!viewImageRecord">
                                        <i class="fa-regular fa-image"></i>
                                        上下工照片
                                    </mini-button>
                                </template>
                                <template #customRowActions="{row}">
                                    <div class="d-flex flex-row w-100 h-100">
                                        <b-badge v-if="row.toWorkImg==='BY_PWD'">密码上工</b-badge>
                                        <b-img v-else-if="row.toWorkImg" :src="generateImageUrl(row.toWorkImg)"
                                               fluid-grow
                                               alt="上工" class="img-style"></b-img>
                                        <template v-else></template>
                                        <b-badge v-if="row.offWorkImg==='BY_PWD'">密码下工</b-badge>
                                        <b-img v-else-if="row.offWorkImg" :src="generateImageUrl(row.offWorkImg)"
                                               fluid-grow
                                               alt="下工" class="img-style"></b-img>
                                        <template v-else></template>
                                    </div>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>

    </div>
</template>
<script>
// Author Eric
// Date 2023-11-29 13:03:04

import emCommonListMixin from "@/mixin/em/common/list";
import emCustomVuexMixin from "@/mixin/em/customVuex";
import MiniButton from "@/components/common/buttons/MiniButton.vue";
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";

export default {
    name: "sithMesPrdWorkHourRecordListView",
    components: {MiniButton},
    mixins: [emCommonListMixin, emCustomVuexMixin, emCommonUtilMixin],
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    data() {
        return {
            viewImageRecord: false
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        }
    },
    methods: {
        generateImageUrl(uuid) {
            if (uuid) {
                return process.env.VUE_APP_EM_ADMIN_URL + "/emAclUser/faceRecord/download?imgUUID=" + uuid
                    + this.getUrlTokenStr();
            }
        },
    }
};
</script>

<style scoped>
.img-style {
    max-height: 100px;
    width: auto !important;
}
</style>
